// extracted by mini-css-extract-plugin
export default {"hideScroll":"eCommers_hideScroll__FDlxO"};